import { useState } from "react"
import { getKeywords } from "../../api/api"
import { compactNumber, scoreTone } from "../../utils/seo"

export default function Keywords() {
  const [domain, setDomain] = useState("")
  const [data, setData] = useState(null)
  const [error, setError] = useState("")

  async function load() {
    setError("")
    try {
      const res = await getKeywords(domain)
      setData(res.data)
    } catch (err) {
      setError(err.response?.data?.error || "Failed to load keyword data")
    }
  }

  const opportunities = data?.opportunities || []
  const clusters = data?.clusters || []
  const rawKeywords = data?.keywords || []

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Keyword Magic</h1>
          <p className="muted">Opportunity, intent, difficulty and topical cluster data from the latest audit.</p>
        </div>
      </div>

      <div className="card form-row">
        <label>
          Domain
          <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="example.com" />
        </label>
        <button onClick={load}>Load keywords</button>
      </div>

      {error && <p className="error">{error}</p>}

      {data && (
        <>
          <div className="grid">
            <div className="metric-card">
              <p className="metric-label">Keyword targets</p>
              <div className="metric">{compactNumber(opportunities.length || rawKeywords.length)}</div>
              <p className="muted">Discovered from crawled page titles, headings and snippets</p>
            </div>
            <div className="metric-card">
              <p className="metric-label">Topic clusters</p>
              <div className="metric">{compactNumber(clusters.length)}</div>
              <p className="muted">Grouped into topical growth buckets</p>
            </div>
            <div className="metric-card">
              <p className="metric-label">Best potential</p>
              <div className="metric">{opportunities[0]?.potential || 0}/100</div>
              <p className="muted">{opportunities[0]?.keyword || "Run an audit first"}</p>
            </div>
          </div>

          <div className="split-grid pro-section">
            <div className="card">
              <h2>Keyword Opportunities</h2>
              <div className="table-wrap">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Keyword</th>
                      <th>Intent</th>
                      <th>Volume</th>
                      <th>Difficulty</th>
                      <th>Potential</th>
                      <th>Page Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {opportunities.map((item) => (
                      <tr key={item.keyword}>
                        <td><strong>{item.keyword}</strong></td>
                        <td>{item.intent}</td>
                        <td>{compactNumber(item.volumeEstimate)}</td>
                        <td><span className="pill medium">{item.difficultyScore}</span></td>
                        <td><span className={`status ${scoreTone(item.potential)}`}>{item.potential}/100</span></td>
                        <td>{item.recommendedPageType}</td>
                      </tr>
                    ))}
                    {opportunities.length === 0 && (
                      <tr>
                        <td colSpan="6" className="muted">No keyword opportunities yet. Run a site audit first.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card">
              <h2>Topic Clusters</h2>
              <div className="cluster-list">
                {clusters.map((cluster) => (
                  <div className="cluster-card" key={cluster.topic}>
                    <div className="score-bar-top">
                      <strong>{cluster.topic}</strong>
                      <span className={`status ${scoreTone(cluster.potential)}`}>{cluster.potential || 0}/100</span>
                    </div>
                    <p className="muted">{(cluster.keywords || []).slice(0, 12).join(", ")}</p>
                  </div>
                ))}
                {clusters.length === 0 && <div className="empty-state">No clusters yet.</div>}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
